export default __webpack_public_path__ + "static/media/gallery-wip-head-pins_04.85685581.jpg";